<template>
  <div class="add-blacklist">
    <div class="file-block">
      <div v-show="!selectedFile" class="set-file-btn">
        <label for="file-input" class="file-label">Добавить ЧС</label>
        <input id="file-input" type="file" ref="fileInput" accept=".xlsx, .xls" class="file-input" @change="handleFileChange" />
      </div>
      <p v-if="selectedFile" class="file-name">{{selectedFile.substring(0, 15)}}...</p>
    </div>
    
    <div>
      <button v-if="selectedFile" @click="submit" class="upload-button" :disabled="uploading">
        {{ uploading ? 'Отправка…' : 'Отправить' }}
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import ApiConnector from '@/backend/apiModels/userApi'
import { createToaster } from "@meforma/vue-toaster";

export default {
  name: 'DriverBlackList',
  props:['customerId'],
  setup(props) {
    const fileInput = ref(null);
    const selectedFile = ref('');
    const uploading = ref(false)
    const api = new ApiConnector()
    const toaster = createToaster()

    const handleFileChange = () => {
      const file = fileInput.value.files[0];
      if (file) {
        selectedFile.value = file.name;
      } else {
        selectedFile.value = '';
      }
    };

    
    const submit = async () => {
      const file = fileInput.value.files[0];
      if (!file || uploading.value) return
      uploading.value = true
      try {
        const { response, request } = api.updateCustomerTable('customers/black-list/'+props.customerId,file);
        await request();
        if (response.value?.msg) {
          toaster.success(response.value.msg)
        } else {
          toaster.error('Не удалось загрузить ЧС')
        }
      } catch {
        toaster.error('Ошибка загрузки ЧС')
      } finally {
        uploading.value = false
        if (fileInput.value) fileInput.value.value = ''
        selectedFile.value = ''
      }
    }

    return {
      fileInput,
      selectedFile,
      uploading,
      handleFileChange,
      submit,
    };
  },
};
</script>

<style scoped>
.add-blacklist {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.file-block{
  display: flex;
  align-items: center;
}

.file-label {
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.file-label:hover {
  background-color: #0056b3;
}

.file-label:active {
  background-color: #00499a;
}

.file-label:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}

.file-input {
  display: none;
}

.file-name{
  margin-left: 10px;
}

.upload-button {
  margin-top: 16px;
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.upload-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.upload-button:hover {
  background-color: #0056b3;
}

.upload-button:active {
  background-color: #00499a;
}

.upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}

</style>
